import React from 'react'

import './_section.scss'

import cn from '../../libs/class-names'

import {CommonProps, Overwrite} from '../../types'

type Props = Overwrite<
  CommonProps<'section'>,
  {
    children: React.ReactNode
  }
>

const Section = ({className, children, ...props}: Props) => (
  <section {...props} className={cn('Section', {}, className)}>
    {children}
  </section>
)

export default Section
